import { useContext } from 'react';
import { IDonorSearchResult } from '@nkr/models/index';
import { Glyphicon } from 'react-bootstrap';
import { DonorSearchContext } from './context';
import Workflow from './workflow';

interface IProps {
    index: number,
    data: IDonorSearchResult,
    isInDonorShield: boolean
}

const ListRow = (props: IProps) => {
    const context = useContext(DonorSearchContext);

    const handleRowClick = () => {
        context.doExpand(props.index);
    };

    const item = props.data;
    const isExpanded = props.index == context.selectedIndex;
    const border = isExpanded ? '1px solid cornflowerblue' : '0 none';
    const backgroundColor = isExpanded ? 'cornflowerblue' : (props.index % 2 == 0 ? '#eee' : '#fff');
    const color = isExpanded ? 'white' : 'initial';

    return (
        <>
            <tr title='Click to expand...' style={{ cursor: 'pointer', border, backgroundColor, color }} onClick={handleRowClick}>
                <td><Glyphicon glyph={isExpanded ? 'chevron-down' : 'chevron-right'} /></td>
                <td>{props.index + 1}</td>
                <td>{item.fullName}</td>
                <td>{item.birthDate}</td>
                <td>{item.age}</td>
                <td>{item.alias}</td>
                <td>{item.gender}</td>
                <td>{item.email}</td>
                <td>{item.registrationDate}</td>
                <td>{item.donationDate}</td>
                <td>{item.registrationId > 0 && (<Glyphicon glyph='ok' />)}</td>
                <td>{item.donorId > 0 && (<Glyphicon glyph='ok' />)}</td>

                {props.isInDonorShield && (
                    <td>{item.donorShieldDirectId > 0 && (<Glyphicon glyph='ok' />)}</td>
                )}

                <td>{item.watrRequestId > 0 && (<Glyphicon glyph='ok' />)}</td>
                <td>{item.followUpDonorId > 0 && (<Glyphicon glyph='ok' />)}</td>
            </tr>
            {isExpanded && (
                <tr>
                    <td colSpan={15} style={{ textAlign: 'left', padding: '20px 20px 20px 20px', border: '1px solid cornflowerblue' }}>
                        <Workflow
                            data={item}
                            isInDonorShield={props.isInDonorShield}
                        />
                    </td>
                </tr>
            )}
        </>
    );
}

export default ListRow;